import "./styles.css";
import { mountApp } from "./ui/app.js";

mountApp();
